import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
// import { environment2 } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  baseUrl = 'https://admin.waslaegy.com/api/'
  // private baseUrl = environment2.backend.baseURL;
  token = ''
  constructor(private http: HttpClient,private router: Router) {
    this.token = localStorage.getItem('userToken')
  }

  private now = Math.floor(Date.now() / 1000);
  public checkExpiration() {
    const exp = parseInt(localStorage.getItem('exp'));
    // const userData = this.cookieService.get('userData');
    if (exp) {
      // console.log(exp)
      this.now = Math.floor(Date.now() / 1000)
      // const userObject = JSON.parse(userData);
      // const expDateString = exp
      // console.log('exp: '+expDateString)
      // console.log('now '+this.now)
  
      // Convert the expiration date string to a Date object
      const expDate = new Date(exp).getTime(); // Convert to timestamp in seconds
      console.log('exp: '+ expDate + ' now: '+this.now)
      if (this.now > expDate || !this.token) {
        
        // console.log('Token expired, logging out...');
        setTimeout(() => {
          this.logout();  // Call a logout function to clear storage and redirect
          return false;
        }, 2000);
      }
    }
    
    // console.log('Token is still valid.');
    return true;
  }
  public logout() {
    localStorage.removeItem('userToken')
    localStorage.removeItem('userName')
    localStorage.removeItem('ID')
    localStorage.removeItem('OrganizationID')
    localStorage.removeItem('exp')
    localStorage.removeItem('userData')
    localStorage.removeItem('deliveryCost')
    localStorage.removeItem('exp')
    localStorage.removeItem('quantity')
    this.router.navigate(['/login-register']);
  }

  private createHeaders() {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json')
    headers.append('Accept', 'application/json')
    headers.append('Access-Control-Allow-Origin', '*')
    return headers;
  }
  
  public Login(body: any): Observable<any> {
    return this.http.post(`${this.baseUrl}auth/login`, body);
  }

  public signup(body: any): Observable<any> {
    return this.http.post(`${this.baseUrl}auth/signup`, body);
  }

  public ads(): Observable<any> {
    return this.http.get(`${this.baseUrl}app/main/ads`);
  }

  public categories(): Observable<any> {
    return this.http.get(`${this.baseUrl}app/main/categories`);
  }

  public offers(): Observable<any> {
    return this.http.get(`${this.baseUrl}app/offers`);
  }

  public countries(): Observable<any> {
    return this.http.get(`${this.baseUrl}app/countries`);
  }

  public allVendors(body: any): Observable<any> {
    return this.http.post(`${this.baseUrl}app/search?page=1`,body);
  }

  public allVendorsForSpecificCategory(catId: number): Observable<any> {
    return this.http.get(`${this.baseUrl}app/category/vendors/${catId}`);
  }

  public vendorSearch(vendorId: number,productName: string): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.post(`${this.baseUrl}app/vendorSearch/${vendorId}?per_page=10&key=${productName}`,{headers});
  }

  public subCategories(id: number): Observable<any> {
    this.checkExpiration()
    return this.http.get(`${this.baseUrl}app/category/sub-categories/${id}`);
  }

  public selectedVendor(vandorID: number,counter: number): Observable<any> {
    return this.http.get(`${this.baseUrl}app/vendor/${vandorID}?page=${counter}`);
  }

  public allVendorSubCategory(vandorID: number,counter: number): Observable<any> {
    return this.http.get(`${this.baseUrl}app/vendor/sub-categories/${vandorID}?page=${counter}`);
  }

  public allSubCategoryProducts(subID: number,counter: number): Observable<any> {
    this.checkExpiration()
    return this.http.get(`${this.baseUrl}app/sub-category/${subID}/products?page=${counter}`);
  }

  public filter(body: any): Observable<any> {
    return this.http.post(`${this.baseUrl}app/filter`,body);
  }

  public specificProduct(productID: number): Observable<any> {
    return this.http.get(`${this.baseUrl}app/product/${productID}`);
  }

  public addToCart(body: any): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.post(`${this.baseUrl}my/cart/add`,body, {headers: headers});
  }
  public getMyCart(): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.get(`${this.baseUrl}my/cart`, {headers});
  }
  public removeCart(id: number): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.delete(`${this.baseUrl}my/cart/remove/${id}`, {headers});
  }

  public addToFav(fav: number): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    console.log(typeof(fav))
    return this.http.post(`${this.baseUrl}my/favorites/vendor/toggle/${fav}`,null, {headers});
  }

  public getMyFav(pageNumber: number): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.get(`${this.baseUrl}my/favorites/vendor?page=${pageNumber}`, {headers});
  }

  public getAddresses(): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.get(`${this.baseUrl}my/addresses`, {headers});
  }

  public setMainAddress(addressID: number): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.post(`${this.baseUrl}my/addresses/set-main/${addressID}`,null, {headers});
  }
 
  public addAddress(body: any): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.post(`${this.baseUrl}my/addresses/add`,body, {headers});
  }

  public deleteAddress(id: number): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.delete(`${this.baseUrl}my/addresses/delete/${id}`, {headers});
  }

  public confirmOrder(body: any): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.post(`${this.baseUrl}my/orders/confirm`,body, {headers});
  }

  public allOrders(): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.get(`${this.baseUrl}my/orders?page=1`, {headers});
  }

  public reorderOrder(id: number): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.post(`${this.baseUrl}my/orders/reorder/${id}`,null, {headers});
  }

  public cancelOrder(id: number): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.post(`${this.baseUrl}my/orders/cancel/${id}`,null, {headers});
  }

  public deleteOrder(id: number): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.delete(`${this.baseUrl}my/orders/delete/${id}`, {headers});
  }

  public orderDetails(id: number): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.get(`${this.baseUrl}my/orders/${id}`, {headers});
  }

  public profile(): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.get(`${this.baseUrl}my/profile`, {headers});
  }

  public updateProfile(body: any): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.post(`${this.baseUrl}my/profile/update`,body, {headers});
  }

  public updateProfileImage(body: any): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.post(`${this.baseUrl}my/profile/image/update`,body, {headers});
  }

  public deleteProfileImage(): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.delete(`${this.baseUrl}my/profile/image/remove`, {headers});
  }

  public deleteProfile(): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.delete(`${this.baseUrl}my/profile/delete`, {headers});
  }

  public getFavorites(): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.get(`${this.baseUrl}my/favorites/vendor?page=1`, {headers});
  }

  public getFavoriteProducts(): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.get(`${this.baseUrl}my/favorites/product?page=1`, {headers});
  }
  public toggleFavoriteProduct(fav: number): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.post(`${this.baseUrl}my/favorites/product/toggle/${fav}`,null, {headers});
  }

  public changePassword(body: any): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.post(`${this.baseUrl}my/profile/password/change`,body, {headers});
  }

public emptyCart(): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth_token': `${this.token}`,
      'locale': 'ar'
    });
    return this.http.delete(`${this.baseUrl}my/cart/empty`, {headers});
  }

  public sendOtpToMailAfterSignup(body: any): Observable<any> {
    this.checkExpiration()
    const tokenToVerify = localStorage.getItem('userToken_to_verify')
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'locale': 'en',
      'Authorization': `Bearer ${tokenToVerify}`,
      'auth-token': `${tokenToVerify}`,
    });
    return this.http.post(`${this.baseUrl}my/profile/send_otp_to_custom_email`,body, {headers});
  }
  public verifyOtp(body: any): Observable<any> {
    this.checkExpiration()
    const tokenToVerify = localStorage.getItem('userToken_to_verify')
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${tokenToVerify}`,
      'auth-token': `${tokenToVerify}`,
      'locale': 'en'
    });
    return this.http.post(`${this.baseUrl}my/profile/verify_otp`,body, {headers});
  }
}
